export const truncate = (fullString: string, maxLength: number) => {
  if (fullString?.length > maxLength) {
    const sub = fullString.substring(0, maxLength)
    const arrs = sub.split(" ")
    return arrs.filter((arr: string, index: number) => index !== arrs.length - 1).join(" ") + "...";
  }
  return fullString;
};

export function onlyUnique(value: any, index: number, self: any) {
  return self.indexOf(value) === index;
}

export function handleHrefChangeLocale(current: string, next: string, pathname: string, referrer?: string) {
  // console.log('running base')
  if (next === current) {
    return ""
  }
  if (!!referrer && referrer !== "") {
    // console.log("here")
    return `/${next}/${referrer}/`
  }
  const rgxOne = new RegExp(`^[/]{1}${current}[/]{1}`)
  if (pathname.match(rgxOne)) {
    // console.log('match one')
    return pathname.replace(rgxOne, `/${next}/`)
  }
  const rgxSecond = new RegExp(`^[/]{0,1}(${current}){0,1}`)
  return pathname.replace(rgxSecond, `/${next}`)
}

export function handleHrefChangeLocaleS(current: string, next: string, pathname: string, referrer?: string) {
  // console.log('running base')
  if (next === current) {
    return ""
  }
  if (!!referrer && referrer !== "") {
    // console.log("here")
    return `/${next}/${referrer}/`
  }
  const rgxOne = new RegExp(`^[/]{1}${current}[/]{1}`)
  if (pathname.match(rgxOne)) {
    // console.log('match one')
    return pathname.replace(rgxOne, `/${next}/`)
  }
  const rgxSecond = new RegExp(`^[/]{0,1}(${current}){0,1}`)
  return pathname.replace(rgxSecond, `/${next}/`)
}